import { Box, Fade, Typography } from '@mui/material';

import { certCpe2026 } from '@/images';
import { EVENT_CONSTANTS } from '@/services';

import { YourNextListen } from '../YourNextListen';

const TRANSITION_DURATION = 750;

export const PostQuizAssessmentRecs = ({
  episodeDuration,
  episodeCredits,
}: {
  episodeDuration?: number;
  episodeCredits?: number;
}) => {
  return (
    <Box
      sx={{
        backgroundColor: 'transparent',
        color: 'text.contrast',
        display: 'flex',
        flexDirection: 'column',
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'center',
        gap: 3,
        height: '100%',
      }}>
      <Fade in timeout={{ enter: TRANSITION_DURATION }}>
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 2, sm: 4 },
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'center',
          }}>
          <Box
            component="img"
            src={certCpe2026}
            alt="CPE"
            sx={{ width: { xs: 240, sm: 160 } }}
          />
          <Box sx={{ width: { xs: 240, sm: 360 } }}>
            <Typography variant="h1" sx={{ color: 'text.contrast' }}>
              Well done!
            </Typography>
            {episodeDuration ? (
              <Typography
                variant="body2"
                sx={{ color: 'text.contrast', mb: 2 }}>
                You&apos;ve earned <b>{episodeDuration} minutes</b> of CPD!
              </Typography>
            ) : (
              <Typography
                variant="body2"
                sx={{ color: 'text.contrast', mb: 2 }}>
                You&apos;ve earned <b>{episodeCredits} credits</b> of CPE!
              </Typography>
            )}
            <Typography variant="body2" sx={{ color: 'text.contrast' }}>
              Your certificate is being generated. While you&apos;re waiting
              check out these episodes.
            </Typography>
          </Box>
        </Box>
      </Fade>
      <YourNextListen
        referrer={{
          page: episodeDuration
            ? EVENT_CONSTANTS.PAGE.QUIZ_COMPLETE
            : EVENT_CONSTANTS.PAGE.ASSESSMENT_COMPLETE,
        }}
        transitionDuration={TRANSITION_DURATION}
      />
    </Box>
  );
};
